import axios from "axios";

const district = [];

const STORAGE_KEY = "hm_region_tree_structure";
const STORAGE_TIME_KEY = "hm_region_tree_structure_time";
const CACHE_HOURS = 24;

// 纯净的 axios 实例，避免被项目拦截器注入 token / loading 等，适合请求第三方 CDN
const plainAxios = axios.create();

export function loadAreaData(store) {
  return new Promise((resolve, reject) => {
    // 先尝试从 localStorage 恢复缓存
    try {
      const cached = localStorage.getItem(STORAGE_KEY);
      if (cached) {
        const data = JSON.parse(cached);
        if (Array.isArray(data) && data.length > 0) {
          district.splice(0, district.length, ...data);
        }
      }
    } catch (e) {
      console.warn("读取省市区缓存失败", e);
    }

    // 获取 CDN 路径
    store
      .dispatch("getProvinceCityAreaJson", { id: "getRegionTreeStructure" })
      .then((res) => {
        if (res.code !== "0" || !res.result || !res.result.cdnPath) {
          // 如果接口失败但已有缓存，则使用缓存
          if (district.length > 0) {
            resolve(district);
            return;
          }
          reject(new Error("获取省市区 CDN 路径失败"));
          return;
        }

        const cdnPath = res.result.cdnPath;

        // 检查缓存是否可用（24小时内）
        try {
          const cacheTime = localStorage.getItem(STORAGE_TIME_KEY);
          if (cacheTime && Date.now() - Number(cacheTime) < CACHE_HOURS * 3600 * 1000) {
            // 缓存有效，且 district 已填充，直接返回
            if (district.length > 0) {
              resolve(district);
              return;
            }
          }
        } catch (e) {
          // ignore
        }

        // 加载 CDN JSON（使用无拦截器的实例，避免 CORS 问题）
        // 注意：生产环境需要后端在 CDN 配置 Access-Control-Allow-Origin
        plainAxios
          .get(cdnPath)
          .then((response) => {
            const data = response.data;
            if (Array.isArray(data) && data.length > 0) {
              district.splice(0, district.length, ...data);
              try {
                localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
                localStorage.setItem(STORAGE_TIME_KEY, String(Date.now()));
              } catch (e) {
                console.warn("保存省市区缓存失败", e);
              }
            }
            resolve(district);
          })
          .catch((err) => {
            console.error("加载省市区 CDN 数据失败", err);
            if (district.length > 0) {
              resolve(district);
            } else {
              reject(err);
            }
          });
      })
      .catch((err) => {
        console.error("获取省市区 CDN 路径失败", err);
        if (district.length > 0) {
          resolve(district);
        } else {
          reject(err);
        }
      });
  });
}

export default district;
